import { useState } from 'react';

interface FAQCardProps {
  question: string;
  answer: string;
  className?: string;
}

export function FAQCard({ question, answer, className }: FAQCardProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFAQ = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .faq-card-answer {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .faq-card-answer.open {
            max-height: 200px;
          }
          `,
        }}
      />
      <div
        className={`flex flex-col align-self-stretch overflow-hidden ${className || ''}`}
        style={{
          borderRadius: '14px',
          border: '1px solid #1C2535',
          background: 'rgba(15, 20, 35, 0.60)',
        }}
      >
        <button
          className="flex items-start align-self-stretch justify-between p-6 hover:bg-white/5 transition-colors w-full text-left"
          onClick={toggleFAQ}
        >
          <span
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontWeight: '500',
              lineHeight: '25.6px',
            }}
          >
            {question}
          </span>

          <span
            className="transition-transform duration-300"
            style={{
              color: '#7A8599',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '20px',
              fontWeight: '400',
              lineHeight: '32px',
              transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
            }}
          >
            +
          </span>
        </button>
        <div className={`faq-card-answer ${isOpen ? 'open' : ''}`}>
          <div className="px-6 pb-6 border-t border-white/10">
            <div
              className="pt-4"
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '24px',
              }}
            >
              {answer}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
